import { ReactElement } from 'react';

type TextBannerProps = {
    classes?: string,
    children: any
}

const TextBanner = (props: TextBannerProps) : ReactElement => {
    
    const {
        classes,
        children
    } = props;

    return(
        <div id="text-banner" className={`text-banner ${classes}`}>
            {children}
        </div>
    )
}

export default TextBanner;